import Util from '../forecast-app/shared/util/util';
import {graphql} from 'react-relay';
import {trackAndCommitMutation} from '../tracking/amplitude/TrackMutation';

const mutation = graphql`
	mutation detachProjectFileFromTaskMutation($input: DetachProjectFileFromTaskInput!) {
		detachProjectFileFromTask(input: $input) {
			deletedFileId
			task {
				fileCount
			}
			error
		}
	}
`;

function getConfigs(input) {
	return [
		{
			// RANGE_DELETE removes the edge from the connection without deleting the record from
			// the store -- correct here, because the file still exists on the project.
			type: 'RANGE_DELETE',
			parentID: input.taskId,
			connectionKeys: [
				{
					key: 'Task_referencedFiles',
				},
			],
			pathToConnection: ['task', 'referencedFiles'],
			deletedIDFieldName: 'deletedFileId',
		},
	];
}

function commit(environment, input, onSuccess, onError) {
	return trackAndCommitMutation(environment, {
		mutation,
		variables: {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}},
		configs: getConfigs(input),
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
